import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Typography, Box, Stack/*, TextField*/ } from '@mui/material';


import { ProfileFormData, useStep } from '../wizard/QuestionsForm'
import {  GetSubTitleFromTitleSubtitle } from '../wizard/QuestionsForm'
import { TextFieldDynamicRows } from '../../app/components/TextFieldDynamicRows';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// Define a stateless functional component as an arrow function
export const AnythingToShare: React.FC = () => {
  const { step,  data } = useStep()
  const { getValues, control, formState: { errors } } = useFormContext<ProfileFormData>();
  //const formData =  getValues()
  return (

    <>
      <Controller
        name="comment"
        control={control}
        defaultValue={data.comment}
        render={({ field }) => (
          <>
          <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
              }}
            >
            <Box sx={{
              mb: 1.5,
              px: 1.5,
              py: 1,
              borderRadius: 2,
              backgroundColor: 'rgba(101, 110, 255, 0.06)',
              borderLeft: '3px solid #656EFF',
            }}>
              <Typography variant="body2" sx={{ color: '#444', fontWeight: 500 }}>
                Your story helps connect you with others who share similar experiences — so you don't feel alone, gain insights, and can support others.
              </Typography>
              <Typography variant="caption" sx={{ color: '#888', mt: 0.5, display: 'block', fontStyle: 'italic' }}>
                Tip: Others have shared diagnosis, treatments, medications, stage, treatment location, etc.
              </Typography>
            </Box>
              <TextFieldDynamicRows  sx={{ mb: 1, mt: 1.5, width: '100%', minHeight: '200px',
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#656EFF',
                  },
                },
              }}
              margin="dense"
                multiline
                inputProps={{
                  'data-gramm': 'false',
                  'data-gramm_editor': 'false',
                  'data-enable-grammarly': 'false',
                }}
                InputLabelProps={{ margin: "dense", size: 'small', variant: 'outlined' }}
                InputProps={{
                  sx: {
                    alignItems: 'flex-start',
                    margin: "dense",
                  },
                }}
                label="Share your story"
                placeholder={"e.g. I was diagnosed with Multiple Myeloma in 2023. I'm currently on my second line of treatment with daratumumab and have been responding well. Looking to connect with others on a similar journey."}
                variant="outlined"
                error={!!errors.comment}
                helperText={errors.comment && errors.comment.message}
                value={field.value??''}
                onChange={(event) => {
                  field.onChange(event.target.value)
                }}
              />
            </div>
          </>
        )}
      />
    </>
  )
}